/* eslint-disable import/prefer-default-export */
export const ERROR_MESSAGE_DURATION = 4;
export const MIN_SEARCH_QUERY_LENGTH = 3;
export const DEFAULT_DEBOUNCE_TIME = 500;
